export enum RequisitePsystemTargetType {
    P2P = "p2p",
    WALLET = "wallet"
}